// extracted by mini-css-extract-plugin
export default {"container":"redirector-page_container__2tO3u"};